module.exports = "<p>\n  dmdprecpte works!\n</p>\n"